import type { Idioma } from "./IdiomaProvider";

/** Rótulos compartilhados pelos documentos; cada entrada exige todos os idiomas. */
type Frase = readonly [pt: string, en: string, es: string, zh: string];
const FRASES: readonly Frase[] = [
  ["Pedidos com Itens Cancelados", "Orders with Cancelled Items", "Pedidos con Artículos Cancelados", "含已取消商品的订单"],
  ["Pedidos com Itens Aprovados e Cancelados", "Orders with Approved and Cancelled Items", "Pedidos con Artículos Aprobados y Cancelados", "含已批准和已取消商品的订单"],
  ["Itens aprovados", "Approved items", "Artículos aprobados", "已批准商品"],
  ["Itens cancelados", "Cancelled items", "Artículos cancelados", "已取消商品"],
  ["Itens pendentes", "Pending items", "Artículos pendientes", "待处理商品"],
  ["Valor dos itens cancelados", "Cancelled items value", "Valor de artículos cancelados", "已取消商品金额"],
  ["Motivo do cancelamento", "Cancellation reason", "Motivo de cancelación", "取消原因"],
  ["Gerado em", "Generated on", "Generado el", "生成时间"],
  ["Produtos selecionados", "Selected products", "Productos seleccionados", "已选商品"],
  ["Empresa selecionada", "Selected company", "Empresa seleccionada", "已选企业"],
  ["Responsável pela emissão", "Issued by", "Responsable de emisión", "开具人"],
  ["Filtros aplicados", "Applied filters", "Filtros aplicados", "已应用筛选"],
  ["Todos os Direitos Reservados.", "All Rights Reserved.", "Todos los Derechos Reservados.", "版权所有。"],
  ["Representante", "Representative", "Representante", "代表"],
  ["Preparando páginas do documento…", "Preparing document pages…", "Preparando páginas del documento…", "正在准备文档页面…"],
  ["Arquivo anexado", "Attached file", "Archivo adjunto", "附件文件"],
  ["Documento gerado pelo sistema", "Document generated by the system", "Documento generado por el sistema", "系统生成的文档"],
  ["Gerando relatorio...", "Generating report...", "Generando informe...", "正在生成报表..."],
  ["Permita pop-ups para imprimir o relatório.", "Allow pop-ups to print the report.", "Permita ventanas emergentes para imprimir el informe.", "请允许弹出窗口以打印报表。"],
  ["Logo do sistema", "System logo", "Logotipo del sistema", "系统标志"],
  ["Imagem do emitente", "Issuer image", "Imagen del emisor", "开具方图片"],
  ["Pagador", "Payer", "Pagador", "付款人"],
  ["Faixa de preço", "Price tier", "Rango de precios", "价格档位"],
  ["Estoque de origem", "Source inventory", "Inventario de origen", "来源库存"],
  ["Nenhum item registrado para este documento.", "No items registered for this document.", "No hay artículos registrados para este documento.", "此文档没有商品记录。"],
  ["Obs.", "Notes", "Obs.", "备注"],
  ["Venda sem parcelas financeiras.", "Sale without financial installments.", "Venta sin cuotas financieras.", "此销售单没有财务分期。"],
  ["Nº", "No.", "N.º", "编号"],
  ["Dt Emissão", "Issue date", "Fecha de emisión", "开具日期"],
  ["Documento", "Document", "Documento", "证件"],
  ["Fone", "Phone", "Teléfono", "电话"],
  ["Login do vendedor", "Salesperson login", "Usuario del vendedor", "销售员账号"],
  ["Condição Pgto.", "Payment terms", "Condición de pago", "付款条件"],
  ["Itens da Venda", "Sale Items", "Artículos de la Venta", "销售商品"],
  ["Cód.", "Code", "Cód.", "代码"],
  ["Qtde", "Qty.", "Cant.", "数量"],
  ["UN", "Unit", "Ud.", "单位"],
  ["Q", "Qty.", "Cant.", "数量"],
  ["Vlr Unit", "Unit Price", "Precio Unit.", "单价"],
  ["Vlr Desc", "Discount", "Descuento", "折扣"],
  ["Vlr Total", "Total Amount", "Importe Total", "总金额"],
  ["Condições Comerciais", "Commercial Terms", "Condiciones Comerciales", "商务条款"],
  ["Tipo cartão", "Card type", "Tipo de tarjeta", "银行卡类型"],
  ["Condição", "Terms", "Condición", "条件"],
  ["Totais", "Totals", "Totales", "合计"],
  ["Valor dos Produtos", "Product Amount", "Importe de los Productos", "商品金额"],
  ["Valor do Desconto", "Discount Amount", "Importe del Descuento", "折扣金额"],
  ["Valor dos Juros", "Interest Amount", "Importe de los Intereses", "利息金额"],
  ["Empresa da venda", "Sale company", "Empresa de la venta", "销售企业"],
  ["Pedido de Vendas", "Sales Order", "Pedido de Ventas", "销售订单"],
  ["Forma Pgto.", "Payment Method", "Forma de Pago", "付款方式"],
  ["Prazo Ativação", "Activation Period", "Plazo de Activación", "激活期限"],
  ["Válido até", "Valid until", "Válido hasta", "有效期至"],
  ["Após a data de vencimento acima, este orçamento perde a validade e os valores/condições apresentados poderão ser alterados.", "After the due date above, this quote expires and the amounts/terms shown may change.", "Después de la fecha de vencimiento indicada, este presupuesto pierde validez y los importes/condiciones podrán cambiar.", "超过上述到期日后，此报价失效，所列金额及条件可能变更。"],
  ["Assinatura do Cliente", "Customer Signature", "Firma del Cliente", "客户签名"],
  ["Assinatura do Responsável", "Authorized Signature", "Firma del Responsable", "负责人签名"],
  ["Assinatura do Fornecedor", "Supplier Signature", "Firma del Proveedor", "供应商签名"],
  ["Assinatura do Responsável pela Compra", "Purchasing Representative Signature", "Firma del Responsable de Compra", "采购负责人签名"],
  ["Nenhum item registrado para este pedido.", "No items registered for this order.", "No hay artículos registrados para este pedido.", "此订单没有商品记录。"],
  ["Empresa da compra", "Purchasing company", "Empresa de la compra", "采购企业"],
  ["Condições salvas do pedido", "Saved Order Terms", "Condiciones Guardadas del Pedido", "已保存的订单条件"],
  ["Taxa de parcelamento", "Installment fee", "Tasa de cuotas", "分期费率"],
  ["% NF", "Invoice %", "% Factura", "发票百分比"],
  ["Taxa de NF", "Invoice fee", "Tasa de factura", "发票费率"],
  ["Taxa NF", "Invoice fee", "Tasa Factura", "发票费率"],
  ["Parcelas do Pedido", "Order Installments", "Cuotas del Pedido", "订单分期"],
  ["Condições de Pagamento", "Payment Terms", "Condiciones de Pago", "付款条件"],
  ["Não foi possível carregar o pedido de compra para impressão.", "Unable to load the purchase order for printing.", "No se pudo cargar el pedido de compra para imprimir.", "无法加载待打印的采购订单。"],
  ["Pedido de compra", "Purchase order", "Pedido de compra", "采购订单"],
  ["Permita pop-ups para gerar o catálogo.", "Allow pop-ups to generate the catalog.", "Permita ventanas emergentes para generar el catálogo.", "请允许弹出窗口以生成目录。"],
  ["Emissão de Nota Fiscal", "Invoice Issuance", "Emisión de Factura", "开具发票"],
  ["Prévia NF", "Invoice Preview", "Vista Previa de Factura", "发票预览"],
  ["PRÉVIA · SEM VALOR FISCAL", "PREVIEW · NOT A VALID TAX DOCUMENT", "VISTA PREVIA · SIN VALOR FISCAL", "预览 · 无税务效力"],
  ["Município", "City", "Municipio", "城市"],
  ["Descrição simples do produto", "Simple product description", "Descripción simple del producto", "商品简述"],
  ["Setor", "Section", "Sector", "分区"],
  ["Rua", "Aisle", "Pasillo", "通道"],
  ["Num.", "No.", "N.º", "编号"],
  ["Lote", "Batch", "Lote", "批次"],
  ["Comp.", "Length", "Largo", "长度"],
  ["Larg.", "Width", "Ancho", "宽度"],
  ["Alt.", "Height", "Alto", "高度"],
  ["Peso bruto (kg)", "Gross weight (kg)", "Peso bruto (kg)", "毛重（千克）"],
  ["Peso líquido (kg)", "Net weight (kg)", "Peso neto (kg)", "净重（千克）"],
  ["Preço un", "Unit price", "Precio unit.", "单价"],
  ["Preço T.", "Total price", "Precio total", "总价"],
  ["Transportador/Volumes transportados", "Carrier / Shipped Packages", "Transportista / Bultos Transportados", "承运商／运输件数"],
  ["Frete por conta", "Freight paid by", "Flete por cuenta de", "运费承担方"],
  ["Código ANTT", "ANTT code", "Código ANTT", "ANTT 代码"],
  ["Placa do veículo", "Vehicle plate", "Matrícula del vehículo", "车牌号"],
  ["O pedido não possui itens disponíveis para a prévia da NF.", "The order has no items available for the invoice preview.", "El pedido no tiene artículos disponibles para la vista previa de la factura.", "此订单没有可用于发票预览的商品。"],
  ["Não foi possível carregar uma imagem anexada ao relatório.", "Unable to load an image attached to the report.", "No se pudo cargar una imagen adjunta al informe.", "无法加载报表附件图片。"],
  ["Preparando os arquivos anexados para impressão…", "Preparing attached files for printing…", "Preparando los archivos adjuntos para imprimir…", "正在准备打印附件…"],
  ["O PDF anexado exige senha. Anexe uma cópia sem senha para imprimi-lo no relatório.", "The attached PDF requires a password. Attach a copy without a password to print it in the report.", "El PDF adjunto requiere contraseña. Adjunte una copia sin contraseña para imprimirlo en el informe.", "附件 PDF 需要密码。请附上无密码副本以在报表中打印。"],
  ["Não foi possível preparar os anexos do relatório.", "Unable to prepare the report attachments.", "No se pudieron preparar los adjuntos del informe.", "无法准备报表附件。"],
  ["A impressão não foi iniciada.", "Printing was not started.", "La impresión no se inició.", "打印尚未开始。"],
];

const COLUNAS = { pt: 0, en: 1, es: 2, "zh-CN": 3 } as const;
export const TEXTOS_RELATORIOS = Object.fromEntries(Object.entries(COLUNAS).map(([idioma, coluna]) => [
  idioma, Object.fromEntries(FRASES.map((frase) => [frase[0], frase[coluna]])),
])) as Record<Idioma, Record<string, string>>;

/** Traduz somente os trechos fixos; identificadores e nomes capturados permanecem literais. */
export function traduzirFraseRelatorio(texto: string, idioma: Idioma, traduzir: (texto: string) => string): string | null {
  if (idioma === "pt") return null;
  const titulo = texto.match(/^(Pedido de Compras?|Pedido de Vendas|Venda|Orçamento|Prévia NF|Prévia da NF|Separação do Pedido|Recibo de pagamento)(\s*(?:#|[-–—])\s*)(.+)$/i);
  if (titulo) return `${traduzir(titulo[1])}${titulo[2]}${titulo[3]}`;
  const exibindo = texto.match(/^Exibindo\s+(\d+)(?:\s+de\s+(\d+))?\s+registros?$/i);
  if (exibindo) {
    const [, total, disponiveis] = exibindo;
    if (idioma === "en") return `Showing ${total}${disponiveis ? ` of ${disponiveis}` : ""} record(s)`;
    if (idioma === "es") return `Mostrando ${total}${disponiveis ? ` de ${disponiveis}` : ""} registro(s)`;
    return `显示 ${total}${disponiveis ? ` / ${disponiveis}` : ""} 条记录`;
  }
  const direitos = texto.match(/^(©\s+\d{4}\s+.+?\s+-\s+)Todos os Direitos Reservados\.?$/i);
  if (direitos) return `${direitos[1]}${traduzir("Todos os Direitos Reservados.")}`;
  const anexo = texto.match(/^Anexo\s+(\d+)$/i);
  if (anexo) return `${idioma === "en" ? "Attachment" : idioma === "es" ? "Adjunto" : "附件"} ${anexo[1]}`;
  const secoes = texto.match(/^(\d+)\s+seç(?:ão|ões)$/i);
  if (secoes) return `${secoes[1]} ${idioma === "en" ? "section(s)" : idioma === "es" ? "sección(es)" : "个分区"}`;
  const pagina = texto.match(/^Página\s+(\d+)\s+de\s+(\d+)$/i);
  if (pagina) {
    if (idioma === "en") return `Page ${pagina[1]} of ${pagina[2]}`;
    if (idioma === "es") return `Página ${pagina[1]} de ${pagina[2]}`;
    return `第 ${pagina[1]} 页，共 ${pagina[2]} 页`;
  }
  const observacao = texto.match(/^Pedido gerado pela venda\s+(\d+)\s+-\s+itens do estoque de\s+(.+?)\.?$/i);
  if (observacao) {
    if (idioma === "en") return `Order generated from sale ${observacao[1]} - items from ${observacao[2]}'s inventory.`;
    if (idioma === "es") return `Pedido generado por la venta ${observacao[1]} - artículos del inventario de ${observacao[2]}.`;
    return `由销售单 ${observacao[1]} 生成的订单 - 商品来自 ${observacao[2]} 的库存。`;
  }
  return null;
}
